import { render, staticRenderFns } from "./BundleID.vue?vue&type=template&id=2a066a60&"
import script from "./BundleID.vue?vue&type=script&lang=js&"
export * from "./BundleID.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports